
function* request({ url, method = 'GET', body = '', headers = {}, onSuccess = () => {}, onError = () => {} }) {
  let fetchParams = {
    method,
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers,
    redirect: 'follow',
    referrer: 'no-referrer',
    keepalive: true,
  };

  if (method === 'GET') {
    if (body) {
      url += `?${body}`;
    }
  } else {
    fetchParams.body = body;
  }

  try {
    const response = yield fetch(url, fetchParams);
    let result;
    try {
      result = yield response.json();
    } catch (ignore) { /* ignore */ }
    if (response.status !== 200) {
      return yield onError(result);
    }
    return yield onSuccess(result);
  } catch (error) {
    return yield onError(error);
  }
}

export default request
